import React, { useEffect, useState, useRef } from 'react';
import styled from '@emotion/styled';
import { useFormik, ErrorMessage } from 'formik';
import Select from '../../../../common/Select';
import Button from '../../../../common/Button';
import { TAB_MODS } from '../../../../../config/mods';
import {
  fetchGetEshopInfoList,
  fetchGetEshopPriceType,
  fetchPostEshopExportAllNomenclature,
  fetchPostEshopInfoList,
  fetchPostEshopTestConnection,
} from '../../../../../actions/admin';
import { useDispatch, useSelector } from 'react-redux';

import { MarketplaceTypeSelect } from './forms/FormSelects';
import { MainMarketplacesForm } from './forms/CustomForms';
import AdditionalMarketplacesForm from './forms/AdditionalForm';
import * as Yup from 'yup';
import SpinnerBlock from '../../../../common/SpinnerBlock';

const Wrapper = styled('form')`
  .col-12 {
    padding: 0;
  }

  .text-center {
    width: 100%;
    text-align: center;
  }

  .table .thead-light th:nth-child(n + 2) {
    text-align: center !important;
  }

  .buttons-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }

  .save-button {
    margin-right: auto;
  }

  .line {
    height: 1px;
    background: #dee2e6;
    margin: 27px 0 5px;
  }
`;

const validationSchema = Yup.object().shape({
  // type: Yup.string().required('Выберите тип маркетплейса'),
  // name: Yup.string().required('Обязательное поле'),
  // type: Yup.string().required('Обязательное поле'),
  // isActive: Yup.string().required('Обязательное поле'),
  // percentStock: Yup.number()
  //   .typeError('Значение может быть только числом')
  //   .min(0, 'Значение не может быть меньше 0')
  //   .max(100, 'Значение не может быть больше 100')
  //   .required('Обязательное поле'),
});

const WarningMessage = () => (
  <div class="alert alert-warning warning">
    <div>
      <i class="mdi mdi-alert-outline mr-1"></i>Для создания магазина заполните основные реквизиты:
    </div>
    <div>
      <b>МП, Название магазина, Склад</b>.
    </div>
    <div>После первого сохранения станет доступен полный набор настроек.</div>
  </div>
);

const MarketplaceForms = (props) => {
  const { handleSwitchMarketplaceMode, mode, marketplaceCode, organization } = props;

  const [currentMarketplace, setCurrentMarketplace] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [updatedAdditionalProperties, setUpdatedAdditionalProperties] = useState(null);

  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      type: '',
      name: '',
      isActive: '',
      warehouse: null,
    },
    onSubmit: async (values) => {
      const convertedValues = {
        ...values,
        percentStock: parseInt(values.percentStock),
      };

      if (values.code) delete convertedValues.type;

      try {
        const result = await dispatch(fetchPostEshopInfoList(convertedValues));

        if (result.code) {
          await handleGetMarketplaceByCode(result.code);
        }

        if (mode === TAB_MODS.EDIT) handleSwitchMarketplaceMode(TAB_MODS.LIST);
        if (mode === TAB_MODS.ADD) handleSwitchMarketplaceMode(TAB_MODS.EDIT);
      } catch (error) {}
    },
    validationSchema,
  });
  const { values, setValues, setFieldValue, handleSubmit, errors, submitCount } = formik;

  const ref = React.createRef();

  const getAdditionalPropertiesCb = () => {
    if (mode === TAB_MODS.EDIT && ref.current) {
      const additionalData = ref.current.getData();
      setValues({
        ...values,
        additionalProperties: additionalData,
      });
      handleSubmit();
    }

    if (mode === TAB_MODS.ADD) handleSubmit();
  };

  const handleGetMarketplaceByCode = async (code) => {
    const result = await dispatch(fetchGetEshopInfoList(`?code=${code}`));
    setValues(...result.eshopInfoDtoList, false);
    setCurrentMarketplace(result.eshopInfoDtoList);
  };

  const getMarketplaceFullInfoById = async () => {
    try {
      await handleGetMarketplaceByCode(marketplaceCode);
      setIsLoading(false);
    } catch (error) {}
  };

  useEffect(() => {
    if (mode === TAB_MODS.EDIT && marketplaceCode) {
      getMarketplaceFullInfoById();
    }

    if (mode === TAB_MODS.ADD) setIsLoading(false);

    return () => {
      setFieldValue('code', '');
    };
  }, []);

  const handleTestConnection = () => {
    dispatch(fetchPostEshopTestConnection(currentMarketplace[0].code));
  };

  const handleExportAllNomenclature = () => {
    dispatch(fetchPostEshopExportAllNomenclature(currentMarketplace[0].code));
  };

  if (isLoading) return <SpinnerBlock show={true} />;

  return (
    <Wrapper>
      <div className="line"></div>
      <div className="col-12 mb-3 buttons-wrap">
        <Button
          text="&#8592;&nbsp; Отменить изменения и вернуться к списку"
          onClick={() => {
            handleSwitchMarketplaceMode(TAB_MODS.LIST);
          }}
          className="mt-1 mr-2"
        />
        {(mode === TAB_MODS.EDIT || mode === TAB_MODS.ADD) && (
          <Button
            text="Сохранить изменения"
            className="mt-1 save-button"
            onClick={getAdditionalPropertiesCb}
          />
        )}
        {values.code ? (
          <Button
            style={{ backgroundColor: '#8bb743', border: '1px solid #8bb743' }}
            text="Тест соединения"
            className="mt-1 mr-2"
            onClick={handleTestConnection}
          />
        ) : null}
      </div>

      {!values.code && mode === TAB_MODS.ADD && <WarningMessage />}

      <MarketplaceTypeSelect
        value={values.type}
        setFieldValue={setFieldValue}
        errors={errors}
        submitCount={submitCount}
      />
      <MainMarketplacesForm
        values={values}
        setFieldValue={setFieldValue}
        marketplaceType={values.type}
        mode={mode}
      />
      {values.code ? (
        <>
          <Button
            className="mt-2 mb-2"
            text="Экспорт номенклатуры с ценами и остатками"
            onClick={handleExportAllNomenclature}
          />
          <AdditionalMarketplacesForm
            currentMarketplace={currentMarketplace}
            getAdditionalPropertiesCb={getAdditionalPropertiesCb}
            setUpdatedAdditionalProperties={setUpdatedAdditionalProperties}
            ref={ref}
            mode={mode}
          />
        </>
      ) : null}
      <div>
        {/* {values.code && */}

        {/* } */}
      </div>
    </Wrapper>
  );
};

export default MarketplaceForms;
